import { Component, OnInit } from '@angular/core';
import { IUiviews } from './interfaces/IUiviews';
import { ISites } from './interfaces/ISites';
import { AuthService } from './services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'neoris-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  user: string = ''
  userInitials: string = ''
  rolesAndViews: IUiviews[]
  sites: ISites[]
  canViewRealtimeDashboard: boolean = false
  canViewGeneralDashboard: boolean = false
  canViewFastTrackDashboard: boolean = false
  canViewPlantEfficiencyDashboard: boolean = false
  canViewTruckEfficiencyDashboard: boolean = false

  constructor(public authService: AuthService,
    private translate: TranslateService) {
      this.translate.setDefaultLang('en');
      this.translate.addLangs(['en', 'es']);
    }

  ngOnInit(): void {
  }

  login() {
  }

  logout() {
  }

  showMenu (headerToggle, navbarId)  {
    const toggleBtn = document.getElementById(headerToggle),
      nav = document.getElementById(navbarId)

    if (headerToggle && navbarId) {
      toggleBtn.addEventListener('click', () => {
        nav.classList.toggle('show-menu')
        toggleBtn.classList.toggle('bx-x')
      })
    }
  }

  openMenu(){
    this.showMenu('header-toggle', 'navbar')
  }

  setAvatar(user: string) {
    let words = user.split(' ')
    if (words.length > 1) {
      return `${words[0].slice(0,1)}${words[1].slice(0,1)}`.toUpperCase()
    } else {
      return user.slice(0,1).toUpperCase()
    }
  }

  trackByMethod(index: number, el: any): number {
    return el.id;
  }

  setViewMenu(rolesAndViews: IUiviews[]) {
    sessionStorage.setItem('rolesAndViews', JSON.stringify(rolesAndViews));

    rolesAndViews.forEach(element => {
      switch (element.menU_ID) {
        case 2:
          this.canViewRealtimeDashboard = true
          break
        case 3:
          this.canViewGeneralDashboard = true
          break
        case 4:
          this.canViewFastTrackDashboard = true
          break
        case 5:
          this.canViewPlantEfficiencyDashboard = true
          break
        case 6:
          this.canViewTruckEfficiencyDashboard = true
          break
      }
    })
  }

  toogle() {
  }
}
